import { telaSobDemanda, type TelaRotina } from '../tipoTelaRotina';

export const telasFIS: Record<string, TelaRotina> = {
  'fis/previa-fiscal': telaSobDemanda(() => import('../../../modulos/FIS/PaginaPreviaFiscal'), 'PaginaPreviaFiscal'),
};

/** Ações extras na lista genérica (`acoesListaRotina`). */
export const acoesListaFIS: Record<string, TelaRotina> = {
  FIS120: telaSobDemanda(() => import('../../../modulos/FIS/ImportarEntrada'), 'BotaoImportarEntrada'),
  FIS140: telaSobDemanda(() => import('../../../modulos/FIS/Inutilizar'), 'BotaoInutilizar'),
};
